import { useTranslation } from 'react-i18next';
import { ErpAlert, ErpDiv, ErpSpan } from '@/components/erp';
import { useBusinessTime } from '@/redux/api/businessClockApi';
import BusinessClockButton from '@/views/app/pages/opening_inventory/BusinessClockButton';

export default function BusinessClockBanner() {
  const { t } = useTranslation();
  const { data, error } = useBusinessTime();
  if (error) return <ErpAlert variant="warning">{t('Business_Clock_Unavailable')}</ErpAlert>;
  if (!data?.enabled) return null;
  return <ErpAlert variant="warning" className="mb-4">
    <ErpDiv className="flex flex-wrap items-center justify-between gap-3">
      <ErpSpan>{t('Business_Clock_Active')}: <ErpSpan dir="ltr" className="inline-block">{data.businessNow} ({data.timezone})</ErpSpan></ErpSpan>
      <BusinessClockButton canManage={data.canManage} />
    </ErpDiv>
  </ErpAlert>;
}
